export default __webpack_public_path__ + "static/Vacuum_Compartment-678c569ca8dfbcae4c574673c8f010d5.png";